import React from 'react';
import {withRouter} from 'react-router-dom';

import ImportExportRecords from '../../components/shared/ImportExportRecords/ImportExportRecords';

const ImportRecords = ({
    user
}) => {

    return (
        <ImportExportRecords 
            user={user}
            s_type={'IMPORT'}
        />
    );
}

export default withRouter(ImportRecords);